import { Injectable } from '@angular/core';
import { formatDistanceToNow } from 'date-fns';

interface NotificationPushService {
  id: number;
  value: boolean;
}

export interface AlertData {
  title: string;
  use_alert_title_as_subject: boolean;
  deviation_threshold_value: number;
  deviation_period: number;
  deviation_direction: number;
  privacy_id: boolean;
  description: string;
  trigger_type_id: number;
  notification_posts_count: number;
  trigger_new_posts_count: number;
  notification_post_order_type_id: number;
  filters?: any; // Assuming filters is a string, but it might be more complex.
  notification_push_service?: NotificationPushService[];
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  formatTimestampToNow(value: string | number | Date) {
    if (!value) return '';
    return formatDistanceToNow(new Date(value), { addSuffix: true });
  }
}
